import { render, staticRenderFns } from "./ImprovementsFooter.vue?vue&type=template&id=6a96c8fb"
import script from "./ImprovementsFooter.vue?vue&type=script&lang=js"
export * from "./ImprovementsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports